
import { useContext } from "react";
import { useAuth as useAuthFromContext } from "../AuthContext";

export const useAuth = () => {
  return useAuthFromContext();
};
